module.exports = __webpack_public_path__ + "assets/images/vcr_park-01.dd8dbfb72faa11ad065656b24e3d17a0.svg";